import { useState, useEffect } from 'react';

import { find as _find } from 'lodash';

import {
  validateCardNo,
  validateName,
  validateCCV,
  ValidateExpirationData,
} from '../Utils/Validations';

const initProps = {
  cardNo: {},
  nameOnCard: {},
  expirationData: {},
  ccvNo: {},
  cardName: {},
};
function useAddCardsValidation(
  { cardNo, nameOnCard, expirationData, ccvNo, cardName },
  hiddenFields = [],
  validations = {},
) {
  const [validators, setValidators] = useState(initProps);
  const vaildate = (key, value, validateFunction) => {
    // reset validation state
    setValidators(prevValidators => ({
      ...prevValidators,
      [key]: { touched: false },
    }));
    // we don't need to validate empty string so if user writes again err will appear cause of previous err state (emptyString)
    if (!value) {
      return;
    }
    if (validateFunction(value)) {
      setValidators(prevValidators => ({
        ...prevValidators,
        [key]: { touched: true, error: false },
      }));
    } else {
      setValidators(prevValidators => ({
        ...prevValidators,
        [key]: { touched: true, error: true },
      }));
    }
  };
  const removeHiddenFields = () => {
    const newValidators = { ...validators };
    for (const fieldName of hiddenFields) {
      delete newValidators[fieldName];
    }
    return newValidators;
  };
  const isAllInputsVaild = () => {
    const filteredValidators = removeHiddenFields();
    const isValid = !_find(filteredValidators, d => d.error === true || !d.touched);
    const length = Object.values(validators).length;
    if (length === 5 && isValid) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    vaildate('cardNo', cardNo, validations.cardNo || validateCardNo);
  }, [cardNo]);
  useEffect(() => {
    vaildate('nameOnCard', nameOnCard, validations.nameOnCard || validateName);
  }, [nameOnCard]);
  useEffect(() => {
    vaildate('cardName', cardName, validations.cardName || validateName);
  }, [cardName]);
  useEffect(() => {
    vaildate('ccvNo', ccvNo, validations.ccvNo || validateCCV);
  }, [ccvNo]);
  useEffect(() => {
    vaildate(
      'expirationData',
      expirationData,
      validations.expirationData || ValidateExpirationData,
    );
  }, [expirationData]);
  return { validators, isAllInputsVaild };
}
export default useAddCardsValidation;
